<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter 
                    :headers="headers" 
                    :viewName="viewName" 
                    v-on:handle-filter="filter_data">
                </hpo-filter>
                <v-data-table 
                    :headers="headers" 
                    :items="items" 
                    :options.sync="pagination"
                    :server-items-length="total_rows" 
                    :loading="loading" 
                    :footer-props="items_per_page"
                    :mobile-breakpoint="100"
                    fixed-header
                    height="calc(100vh - 300px)">
                    <template v-slot:item="{ item }">
                    <tr @click="openItem(item)" style="cursor: pointer;">
                        <td>{{ item.id }}</td>
                        <td>{{ item.username }}</td>
                        <td>
                        <v-chip small :color="getActionColor(item.action)">
                            {{ getActionName(item.action) }}
                        </v-chip>
                        </td>
                        <td>{{ item.object_type }}</td>
                        <td>{{ item.object_id }}</td>
                        <td>{{ item.created_at | display_date }}</td>
                        <td>{{ item.ip_address }}</td>
                    </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Dialog hiển thị chi tiết -->
    <v-dialog v-model="dialogDetail" max-width="1200px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Chi tiết nhật ký thao tác</span>
        </v-card-title>
        <v-card-text>
          <v-container v-if="currentItem">
            <v-row>
              <v-col cols="6">
                <v-text-field 
                  label="Người thực hiện" 
                  :value="currentItem.username" 
                  readonly>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field 
                  label="Ngày thực hiện" 
                  :value="currentItem.created_at | display_date" 
                  readonly>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field 
                  label="Hành động" 
                  :value="getActionName(currentItem.action)" 
                  readonly>
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field 
                  label="Đối tượng" 
                  :value="currentItem.object_type" 
                  readonly>
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field 
                  label="ID" 
                  :value="currentItem.object_id" 
                  readonly>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field 
                  label="IP Address" 
                  :value="currentItem.ip_address" 
                  readonly>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field 
                  label="User Agent" 
                  :value="currentItem.user_agent" 
                  readonly>
                </v-text-field>
              </v-col>
            </v-row>

            <!-- So sánh dữ liệu cũ và mới -->
            <v-row v-if="currentItem.action === 'UPDATE'">
              <v-col cols="12">
                <h3 class="mb-3">Nội dung thay đổi</h3>
                <v-card outlined>
                  <v-card-text>
                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left" style="width: 30%; color: #FFFFFF;">Trường dữ liệu</th>
                            <th class="text-left" style="width: 35%; color: #FFFFFF">Giá trị cũ</th>
                            <th class="text-left" style="width: 35%; color: #FFFFFF">Giá trị mới</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="change in getChanges()" :key="change.field">
                            <td class="font-weight-bold">{{ change.field }}</td>
                            <td :class="change.hasChanged ? 'red--text text--lighten-1' : ''">
                              <span v-if="change.hasChanged" class="changed-value">
                                {{ getValueDisplay(change.field, change.oldValue) }}
                              </span>
                              <span v-else class="text--secondary">{{ getValueDisplay(change.field, change.oldValue) }}</span>
                            </td>
                            <td :class="change.hasChanged ? 'green--text text--darken-2' : ''">
                              <span v-if="change.hasChanged" class="changed-value">
                                {{ getValueDisplay(change.field, change.newValue) }}
                              </span>
                              <span v-else class="text--secondary">{{ getValueDisplay(change.field, change.newValue) }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row v-else-if="currentItem.action === 'DELETE'">
              <v-col cols="12">
                <h3 class="mb-3">Dữ liệu đã xóa</h3>
                <v-card outlined>
                  <v-card-text>
                    <pre class="code-block">{{ formatJSON(currentItem.old_data) }}</pre>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogDetail = false">Đóng</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";

export default {
  components: { "hpo-filter": Filtering },
  data() {
    return {
      viewName: "nhat-ky-thao-tac",
      dialogDetail: false,
      currentItem: null,
      pagination: { ...configs.PAGINATION },
      items_per_page: { ...configs.ITEMS_PER_PAGE }
    };
  },
  watch: {
    pagination: {
      handler: function () {
        this.filter_data();
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      items: state => state.auditLog.all.data,
      total_rows: state => state.auditLog.all.total,
      loading: state => state.auditLog.loading
    }),
    headers() {
      return [
        {
          text: "ID",
          value: "id",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Người thực hiện",
          value: "username",
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Hành động",
          value: "action",
          filterable: true,
          dataType: configs.DATA_TYPE["Enum"],
          values: [
            { value: 'UPDATE', name: 'Sửa' },
            { value: 'DELETE', name: 'Xóa' }
          ]
        },
        {
          text: "Đối tượng",
          value: "object_type",
          filterable: true,
          dataType: configs.DATA_TYPE["Enum"],
          values: [
            { value: 'Mã hàng', name: 'Mã hàng' },
            { value: 'Xe hàng', name: 'Xe hàng' },
            { value: 'Phiếu xuất', name: 'Phiếu xuất' },
            { value: 'Khách hàng', name: 'Khách hàng' },
            { value: 'Bao hàng TQ', name: 'Bao hàng TQ' },
            { value: 'Bao hàng VN', name: 'Bao hàng VN' },
            { value: 'Phiếu xuất kho', name: 'Phiếu xuất kho' },
            { value: 'Loại hàng', name: 'Loại hàng' },
            { value: 'Bảng giá cân', name: 'Bảng giá cân' },
            { value: 'Bảng giá khối', name: 'Bảng giá khối' },
            { value: 'Kho nhận', name: 'Kho nhận' },
            { value: 'Đơn chính ngạch', name: 'Đơn chính ngạch' },
            { value: 'Lệnh giao CN', name: 'Lệnh giao CN' },
            { value: 'Khai báo CN', name: 'Khai báo CN' },
            { value: 'Thanh toán CN', name: 'Thanh toán CN' },
            { value: 'Dịch vụ CN', name: 'Dịch vụ CN' },
            { value: 'Cấu hình chung', name: 'Cấu hình chung' },
            { value: 'Lịch sử nạp ví', name: 'Lịch sử nạp ví' }
          ]
        },
        {
          text: "ID đối tượng",
          value: "object_id",
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Ngày thực hiện",
          value: "created_at",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "IP Address",
          value: "ip_address",
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        }
      ];
    }
  },
  methods: {
    filter_data: function () {
      let filterConditions = this.$store.state.commons.filterConditions;
      this.filterConditions = filterConditions[this.viewName] || [];
      
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions
      };
      this.$store.dispatch("auditLog/getList", param);
    },
    openItem(item) {
      this.currentItem = item;
      this.dialogDetail = true;
    },
    getActionName(action) {
      const actions = {
        'UPDATE': 'Sửa',
        'DELETE': 'Xóa'
      };
      return actions[action] || action;
    },
    getActionColor(action) {
      const colors = {
        'UPDATE': 'blue',
        'DELETE': 'red'
      };
      return colors[action] || 'grey';
    },
    formatJSON(jsonString) {
      if (!jsonString) return '';
      try {
        const obj = JSON.parse(jsonString);
        return JSON.stringify(obj, null, 2);
      } catch (e) {
        return jsonString;
      }
    },
    getValueDisplay(col, val) {
        if(col == 'Status' && this.currentItem.object_type == 'Mã hàng') {
            const status = configs.PRODUCT_STATUS_LIST ? configs.PRODUCT_STATUS_LIST.find(status => status.value == val) : null;
            return status ? status.name : val;
        }
        else if(col == 'Status' && this.currentItem.object_type == 'Xe hàng') {
            const status = configs.RECEIVE_TYPE_LIST ? configs.RECEIVE_TYPE_LIST.find(status => status.value == val) : null;
            return status ? status.name : val;
        }
        else if(col == 'Status' && this.currentItem.object_type == 'Phiếu xuất') {
            const status = configs.BILL_STATUS_LIST ? configs.BILL_STATUS_LIST.find(status => status.value == val) : null;
            return status ? status.name : val;
        }
        return val;
    },
    getChanges() {
      if (!this.currentItem || !this.currentItem.old_data || !this.currentItem.new_data) {
        return [];
      }
      
      try {
        const oldData = JSON.parse(this.currentItem.old_data);
        const newData = JSON.parse(this.currentItem.new_data);
        const changes = [];
        
        // Lấy tất cả các keys từ cả old và new data
        const allKeys = new Set([...Object.keys(oldData), ...Object.keys(newData)]);
        
        allKeys.forEach(key => {
          const oldValue = oldData[key] !== undefined && oldData[key] !== null ? String(oldData[key]) : '';
          const newValue = newData[key] !== undefined && newData[key] !== null ? String(newData[key]) : '';
          const hasChanged = oldValue !== newValue;
          
          changes.push({
            field: key,
            oldValue: oldValue || '(trống)',
            newValue: newValue || '(trống)',
            hasChanged: hasChanged
          });
        });
        
        // Sắp xếp: các trường thay đổi lên đầu
        return changes.sort((a, b) => {
          if (a.hasChanged && !b.hasChanged) return -1;
          if (!a.hasChanged && b.hasChanged) return 1;
          return a.field.localeCompare(b.field);
        });
      } catch (e) {
        console.error('Error parsing data:', e);
        return [];
      }
    }
  },
  mounted() {
    this.filter_data();
    this.$root.$emit('REQUEST_ROOT_OPTION', {});
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
};
</script>

<style scoped>
.code-block {
  background-color: #f5f5f5;
  padding: 15px;
  border-radius: 4px;
  overflow-x: auto;
  font-size: 12px;
  font-family: 'Courier New', monospace;
  max-height: 400px;
  overflow-y: auto;
}
</style>
